import { render } from "./DiscoverMyData.vue?vue&type=template&id=4d4adebf&scoped=true"
import script from "./DiscoverMyData.vue?vue&type=script&lang=js"
export * from "./DiscoverMyData.vue?vue&type=script&lang=js"

import "./DiscoverMyData.vue?vue&type=style&index=0&id=4d4adebf&lang=scss&scoped=true"
import "./DiscoverMyData.vue?vue&type=style&index=1&id=4d4adebf&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4adebf"]])

export default __exports__